import { Box, SxProps, Theme, Typography } from '@mui/material'

const ErrorMessage = ({ message, error, sx }: {message: string, error: boolean; sx?: SxProps<Theme>}) => {
  return (
    <Box
      sx={{
        height: '25px',
        ...sx
      }}
    >
      {!!error && (
        <Typography
          sx={{
            fontSize: '12px',
            color: '#d32f2f',
            marginLeft: '5px',
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  )
}

export default ErrorMessage
